import Swiper from 'swiper/bundle';

export default class Carousel {
  constructor(element) {
    this.element = element;

    // Variable à utiliser si on utilise un container pour le swiper afin de sortir la navigation du swiper.
    this.parent = this.element.parentElement;

    this.options = {
      slidesPerView: 1,
      spaceBetween: 20,
      direction: 'horizontal',
      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
        type: 'fraction',
        clickable: true,

        renderFraction: function (currentClass, totalClass) {
          return `
            <span class="${currentClass}"></span>
            /
            <span class="${totalClass}"></span>
          `;
        },

        //Permet de formater les chiffres au format 01, 02, 03
        formatFractionCurrent: function (number) {
          return number < 10 ? '0' + number : number;
        },

        formatFractionTotal: function (number) {
          return number < 10 ? '0' + number : number;
        },
      },
      navigation: {
        nextEl: this.element.querySelector('.custom-button-next'),
        prevEl: this.element.querySelector('.custom-button-prev'),
      },
      centeredSlides: false,
      slidesOffsetBefore: 0,
      a11y: true, // Module pour l'accessibilité
      keyboard: {
        enabled: true, // Allouer la navigation par clavier
        onlyInViewport: true,
      },
    };
    this.init();
  }

  updateSlideAccessibility(swiper) {
  swiper.slides.forEach(slide => {
    const focusables = slide.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]'
    );

    const isDuplicate = slide.classList.contains('swiper-slide-duplicate');

    const isVisible = slide.classList.contains('swiper-slide-visible');

    focusables.forEach(el => {
      if (isDuplicate) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      } else {
          el.tabIndex = isVisible ? 0 : -1;
          el.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      }
    });
  });
}

  setOptions() {
    if ('hero' in this.element.dataset) {
      this.options.spaceBetween = 0;
    }

    if ('autoplay' in this.element.dataset) {
      this.options.autoplay = {
        delay: 3000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
    }

    if ('loop' in this.element.dataset) {
      this.options.loop = true;
      this.options.watchSlidesProgress = true;
    }

    if ('fourSlides' in this.element.dataset) {
      this.options.slidesPerView =
        parseFloat(this.element.dataset.fourSlides, 10) ||
        this.options.slidesPerView;
      this.options.breakpoints = {
        1280: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 3,
        },
        600: {
          slidesPerView: 2,
        },
      };
    }

    if ('threeSlides' in this.element.dataset) {
      this.options.slidesPerView =
        parseFloat(this.element.dataset.threeSlides, 10) ||
        this.options.slidesPerView;
      this.options.breakpoints = {
        1280: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 2.5,
        },
        600: {
          slidesPerView: 2,
        },
      };
    }

    if ('twoSlides' in this.element.dataset) {
      this.options.slidesPerView =
        parseFloat(this.element.dataset.twoSlides, 10) ||
        this.options.slidesPerView;
      this.options.breakpoints = {
        1280: {
          slidesPerView: 2,
        },
        600: {
          slidesPerView: 1.5,
        },
      };
    }

    if ('textSwiper' in this.element.dataset) {
      this.options.slidesPerView =
        parseFloat(this.element.dataset.textSwiper, 10) ||
        this.options.slidesPerView;
        this.options.spaceBetween = 0;
      this.options.breakpoints = {
        1440: {
          slidesPerView: 2.5,
          slidesOffsetBefore: 176,
        },
        1280: {
          //slidesPerView: 2.5,
          //slidesOffsetBefore: 176,
          slidesPerView: 2,
          slidesOffsetBefore: 88,
        },
        1024: {
          slidesPerView: 2,
          slidesOffsetBefore: 0,
          centeredSlides: false,
        },
        768: {
          slidesPerView: 1.5,
          slidesOffsetBefore: 0,
          centeredSlides: false,
        },
        600: {
          slidesPerView: 1.2,
          slidesOffsetBefore: 0,
          centeredSlides: false,
        },
      };
    }

    if ('halfSwiper' in this.element.dataset) {
      this.options.slidesPerView =
        parseFloat(this.element.dataset.halfSwiper, 10) ||
        this.options.slidesPerView;
      this.options.breakpoints = {
        1441: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 8,
        },
      };
      this.options.navigation = {
        nextEl: this.parent.querySelector('.custom-button-next'),
        prevEl: this.parent.querySelector('.custom-button-prev'),
      };
    }

    if ('gallery' in this.element.dataset) {
      this.options.slidesPerView =
        parseFloat(this.element.dataset.twoSlides, 10) ||
        this.options.slidesPerView;
      this.options.breakpoints = {
        1280: {
          slidesPerView: 1.5,
        },
      };
      this.options.centeredSlides = true;
      this.options.spaceBetween = 0;
    }

    if ('vertical' in this.element.dataset) {
      this.options.direction = 'vertical';
    }

    if ('spaceBetween' in this.element.dataset) {
      this.options.spaceBetween = this.element.dataset.spaceBetween;
    }

    if ('centeredSlides' in this.element.dataset) {
      this.options.spaceBetween = this.element.dataset.spaceBetween;
    }

    if ('slidesOffsetBefore' in this.element.dataset) {
      this.options.slidesOffsetBefore = this.element.dataset.slidesOffsetBefore;
    }
  }

  init() {
    if (this.element.classList.contains('swiper-initialized')) {
      return;
    }

    this.setOptions();

    if (this.options.loop) {
      this.options.on = {
        init: (swiper) => {
          this.updateSlideAccessibility(swiper);
        },
        slideChange: (swiper) => {
          this.updateSlideAccessibility(swiper);
        }
      };
    }

    this.swiper = new Swiper(this.element, this.options);
  }
}
